import { commonUtils } from '@/helpers/commonUtils'
import styles from './ProfessorDashboardLayout.module.less'
import { Link, Outlet } from 'react-router-dom'
import { DASHBOARD_CONTENT_CONTAINER_ID, PAGE_LINKS } from '@/router/pageConst'
import { Divider, Dropdown } from 'antd'
import DefaultAvatar from '../DefaultAvatar/DefaultAvatar'
import { userService, useUserInfo } from '@/services/userService'
import { observer } from 'mobx-react'
import AIcon from '../A/AIcon/AIcon'
// import ProfessorNavigatorMenu from '../ProfessorNavigatorMenu/ProfessorNavigatorMenu'
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher'

function ProfessorDashboardLayout() {
  const userInfo = useUserInfo()
  const items = [
    {
      key: 'logout',
      label: (
        <DropdownItem
          icon='icon-line-global_exit'
          label={'logout'}
          onClick={() => {
            userService.logout()
          }}
        />
      ),
    },
  ]

  return (
    <div className={styles.professorDashboardLayout}>
      <div className={styles.dashboardLayoutHeader}>
        <div className={styles.headerBox}>
          <Link to={PAGE_LINKS.professorProject} style={{ textDecoration: 'none' }}>
            <img
              className={styles.brand}
              src={commonUtils.getImagePath('homePage/adeff-logo.png')}
              alt=''
            />
          </Link>
          <Divider type='vertical' style={{ marginLeft: 8, marginRight: 12 }} />
          <LanguageSwitcher />
        </div>
        <div className={styles.infoBox}>
          {userInfo && (
            <Dropdown menu={{ items }} placement='bottomRight' dropdownRender={DropdownRender}>
              <span className={styles.userInfo}>
                <DefaultAvatar avatar={userInfo.avatar} name={userInfo.name} />
                <span style={{ whiteSpace: 'nowrap' }}>{userInfo.name}</span>
              </span>
            </Dropdown>
          )}
        </div>
      </div>
      <div className={styles.dashboardLayoutContent}>
        <img
          className={styles.bg3}
          src={commonUtils.getImagePath('dashboardLayout/bg-3.png')}
          alt=''
        />
        {/* <ProfessorNavigatorMenu /> */}
        <div className={styles.dashboardLayoutContentPage} id={DASHBOARD_CONTENT_CONTAINER_ID}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}

function DropdownItem(props: { label: string; icon?: string; onClick?: () => void }) {
  return (
    <div className={styles.dropdownItem} onClick={props.onClick}>
      {props.icon && <AIcon type={props.icon} width={16} height={16} />}
      {props.label}
    </div>
  )
}

function DropdownRender(menus: React.ReactNode) {
  return <div className={styles.dropdownRender}>{menus}</div>
}

export default observer(ProfessorDashboardLayout)
